"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

/**
 * Block context menu (right clicks)
 * @param {element} element - any HTML element you'd like to block right-click on
 * @example `useContextMenuBlocker(element);` or render <ContextMenuBlocker element={element} /> from this folder
 */
const useContextMenuBlocker = element => {
  function block(ev) {
    ev.preventDefault();
  }

  (0, _react.useEffect)(() => {
    element.addEventListener('contextmenu', block);
    return () => {
      element.removeEventListener('contextmenu', block);
    };
  }, []);
};

var _default = useContextMenuBlocker;
exports.default = _default;